import styles from './styles.module.css'
import classNames from 'classnames'

const cloudinaryUrl = 'https://images.angelstudios.com/image/upload'

export const InfiniteScrollCarousel = ({
  images,
  speed = 80000,
}: {
  images: { alt: string; src: string }[]
  speed?: number
}) => {
  return (
    <div
      className="relative h-[140px] w-full overflow-hidden"
      style={{ '--speed': `${speed}ms` } as React.CSSProperties}
    >
      <div className="wrapper absolute flex">
        {[1, 2, 3].map((item) => (
          <section className={classNames(styles.container, 'flex')} key={item}>
            {images.map(({ alt, src }) => (
              <div className="px-5" key={`${alt}-${item}`}>
                <img src={`${cloudinaryUrl}${src}`} alt={alt} className="h-[140px] max-w-[300px] object-contain" />
              </div>
            ))}
          </section>
        ))}
      </div>
    </div>
  )
}
